<template>
  <div class="box-card">
  <br>
    <el-row :gutter="12">
      <el-col :span="19">
        <span class="title">{{ $t("message.title.importMfrp") }}</span>
      </el-col>

      <el-dialog title="导入操作手册" :visible.sync="dialogVisible" width="60%">
        <span class="importManual">
          <p2>第一步：点击“导出模板”按钮，得到导入模板</p2><br /><br />
          <p2>第二步：填写要导入的数据到"物料编码"“制造商名称”和“制造商部件号”三列中。</p2><br /><br />
          <p2>第三步：点击“上传”按钮，导入模板中的数据</p2><br /><br />
          
         </span>
      </el-dialog>
      <el-col style="margin-top: 5px">
        <el-divider></el-divider>
      </el-col>

      
      <el-row style="margin-top: 150px; height: 240px">
          <el-col :span="15" :offset="5" style="font-weight: 600">
            <span>{{ $t("message.title.fileModel") + " : " }}</span>

            <el-button
              type="primary"
              size="small"
              style="margin-left: 70px"
              @click="exportExcel"
              >{{ $t("message.button.exportModel") }}</el-button
            >

          </el-col>

          <el-col :span="15" :offset="5" style="margin-top:25px">
            <el-upload
              class="upload-demo"
              action=""
              :show-file-list="false"
              :before-upload="importFile"
            >
              <span style="display: inline-blcok; font-weight: bold"
                >{{ $t("message.title.fileImport") + " : " }}</span
              >
              <el-button
                size="small"
                type="primary"
                style="margin-left: 70px"
                >{{ $t("message.button.toImport") }}</el-button
              >
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
          </el-col>

          <el-col :span="15" :offset="5" style="margin-top:35px">
            <span>
              <el-tag
              style="margin-left: 0.3%;"
                type="text"
                @click="dialogVisible = true"
                class="tip-tag"
              >
                <i class="el-icon-info" style="font-size:14px"></i>
                <span style="">{{ $t("message.tips.tip") + " : " }}</span
                >{{ $t("message.tips.importMfrpGuide") }}
              </el-tag>
            </span>
          </el-col>
      </el-row>

      
    </el-row>

    <div v-show="false">
        <vxe-grid ref="gridRef" v-bind="exportGridOptions"></vxe-grid>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      exportGridOptions: {
          columns: [],
          data: []
      },


      dialogVisible: false,

      value: "",
 
      fileInfo: [],
      // baseId: 104,
      changeId: "",
      systemName: "",
    };
  },

  methods: {
    
    importFile(file) {


      let fd = new FormData();
      console.log(fd);
      fd.append("file", file);

      axios.post("/pmdm/import/importMfrps", fd).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });

        }
      });
    },

    exportExcel() {
      console.log("exportExcel1");
      try {
        axios.get("/pmdm/import/getImportMfrpExcelFile").then((response) => {

          if (response.data.code == 200) {
            console.log("exportExcel2");
            

            if (!response.data || !response.data.object) {
                throw new Error('Invalid response data');
            }

            const { nameMap, itemPriceVo } = response.data.object;

            let columns = [{ field: 'seq', type: 'seq' }];
            for (let key in nameMap) {
                const hasOwn = Object.prototype.hasOwnProperty;
                if (hasOwn.call(nameMap, key)) {
                    columns.push({
                        field: key,
                        title: nameMap[key]
                    });
                }
            }
            this.exportGridOptions.columns = columns;

            this.exportGridOptions.data = itemPriceVo;

            const  xlsTitle = [nameMap,...itemPriceVo]
            let book = XLSX.utils.book_new();
            let sheet = XLSX.utils.json_to_sheet(xlsTitle, {
                skipHeader: true,
            });
            XLSX.utils.book_append_sheet(book, sheet);
            let wbout = XLSX.write(book, {
                bookType: "xlsx",
                bookSST: false,
                type: "binary",
            });
            let blob = new Blob([this.toBuffer(wbout)], {
                type: "application/octet-stream",
            });
            FileSaver.saveAs(blob, this.$t('message.title.importMfrpTemplate'));
            this.$message({
                showClose: true,
                message: '导出成功！',
                type: 'success'
            });
          }
        });

      } catch (error) {
          console.error('Failed to export price:', error);
      }
    },
    
  },
  created() {
    // this.getTable();
 
    this.systemName = window.sessionStorage.getItem("systemName");
    console.log(this.systemName);
    
  },
};
</script>
<style>

</style>